/* eslint-disable no-else-return */
/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import _ from 'lodash';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import EquipmentActionCreators from 'actions/EquipmentActionCreators';
import EquipmentStore from '../../../stores/EquipmentStore';
import EquipmentRow from './EquipmentRow';
import Alert from '../../ui/Alert';
import ProTip from '../../ui/ProTip';
import { equipmentTypesMapping } from 'constants/Equipment';
const EQUIPMENT_ID_LENGTH_RANGE = [10, 11];
class BulkEditEquipmentModal extends Component {
    constructor(props) {
        super(props);
        this.handleBulkUpdateResultChange = () => {
            const { t } = this.props;
            const result = EquipmentStore.getBulkUpdateResult();
            if (result.successes.length > 0) {
                this.setState({
                    status: t('EQUIPMENTS_UPDATED_SUCCESSFULLY'),
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            status: '',
                        });
                        this.handleHide();
                    }, 4000);
                });
            }
            this.setState({
                saving: false,
            });
        };
        this.handleClearAll = () => {
            const { equipments: currentEquipments } = this.state;
            const equipments = currentEquipments.map(resetEquipment);
            console.log('here');
            this.setState({
                equipments,
            });
        };
        this.handleSave = () => {
            this.setState((currentState) => {
                return {
                    equipments: this.validate(currentState.equipments),
                };
            }, () => {
                if (this.state.equipments.every((e) => e.isValid)) {
                    EquipmentActionCreators.bulkUpdateEquipments(this.transformRequest(this.state.equipments));
                }
            });
        };
        this.handleHide = () => this.props.onHide();
        this.handleFieldChange = (id, field, value) => {
            this.setState((currentState) => {
                const { equipments: currentEquipments } = currentState;
                const index = currentEquipments.findIndex((e) => e._id === id);
                const targetEquipment = _.cloneDeep(currentEquipments[index]);
                targetEquipment[field] = value;
                const isPrivateChassisAttributesResetRequired = ((targetEquipment === null || targetEquipment === void 0 ? void 0 : targetEquipment._equipmentType) !== equipmentTypesMapping.CHASSIS) ||
                    (!targetEquipment.is_private);
                if (isPrivateChassisAttributesResetRequired) {
                    targetEquipment.is_private = null;
                    targetEquipment.chassis_owner = null;
                    targetEquipment.chassis_owner_type = null;
                }
                const isChassisOwnerUpdating = targetEquipment.chassis_owner_type &&
                    targetEquipment.chassis_owner_type === 'cargomatic';
                if (isChassisOwnerUpdating) {
                    targetEquipment.chassis_owner = null;
                }
                if ((targetEquipment === null || targetEquipment === void 0 ? void 0 : targetEquipment._equipmentType) !== equipmentTypesMapping.CONTAINER) {
                    targetEquipment._equipmentSize = null;
                    targetEquipment._type = '';
                }
                const equipments = [
                    ...currentEquipments.slice(0, index),
                    targetEquipment,
                    ...currentEquipments.slice(index + 1),
                ];
                return {
                    equipments,
                };
            });
        };
        this.handleDeselect = (id) => {
            this.setState((currentState) => {
                const { equipments: currentEquipments } = currentState;
                const equipments = currentEquipments.filter((e) => e._id !== id);
                return {
                    equipments,
                };
            });
        };
        this.handleApplyToAll = (id) => {
            this.setState((currentState) => {
                const { equipments: currentEquipments } = currentState;
                const index = currentEquipments.findIndex((eq) => eq._id === id);
                const targetEquipment = currentEquipments[index];
                const { status, _type, _equipmentType, _equipmentSize, is_private, chassis_owner, chassis_owner_type, } = targetEquipment;
                const equipments = currentEquipments.map((eq, i) => {
                    let mapped = Object.assign({}, eq);
                    if (index === i) {
                        return mapped;
                    }
                    /**
                     * Apply all will work only on same assets type
                     */
                    if ((mapped === null || mapped === void 0 ? void 0 : mapped._equipmentType) === (targetEquipment === null || targetEquipment === void 0 ? void 0 : targetEquipment._equipmentType)) {
                        mapped = Object.assign(Object.assign({}, mapped), { status,
                            _type,
                            _equipmentType,
                            _equipmentSize,
                            is_private,
                            chassis_owner,
                            chassis_owner_type });
                    }
                    return mapped;
                });
                return {
                    equipments,
                };
            });
        };
        this.handleCloseTip = () => this.setState({ proTipVisible: false });
        this.validateEquipment = (equipment, i) => {
            const error = {};
            const { t } = this.props;
            const { equipment_id, _equipmentType, _equipmentSize, _type, status, is_private, chassis_owner, chassis_owner_type, } = equipment;
            const rowNumber = i + 1;
            if (!equipment_id) {
                error.equipment_id = `${t('EQUIPMENT')} ${rowNumber} - ${t('ENTER_EQUIPMENT_NUMBER')}`;
            }
            else if (_equipmentType !== 'trailer' &&
                !EQUIPMENT_ID_LENGTH_RANGE.includes(equipment_id.length)) {
                error.equipment_id = `${t('EQUIPMENT')} ${rowNumber} - ${t('EQUIPMENT_NUMBER_EXPECTED_LENGTH', {
                    expectedLengths: EQUIPMENT_ID_LENGTH_RANGE.join(' or '),
                })}`;
            }
            if (!_equipmentType) {
                error._equipmentType = `${t('EQUIPMENT')} ${rowNumber} - ${t('PLEASE_SELECT_ASSET_TYPE')}`;
            }
            else if (_equipmentType === 'container') {
                if (!_type) {
                    error._type = `${t('EQUIPMENT')} ${rowNumber} - ${t('PLEASE_SELECT_EQUIPMENT_TYPE')}`;
                }
                if (!_equipmentSize) {
                    error._equipmentSize = `${t('EQUIPMENT')} ${rowNumber} - ${t('SELECT_EQUIPMENT_SIZE')}`;
                }
            }
            if (!status) {
                error.status = `${t('EQUIPMENT')} ${rowNumber} - ${t('PLEASE_SELECT_EQUIPMENT_STATUS')} `;
            }
            const isChassisPrivate = _equipmentType === equipmentTypesMapping.CHASSIS && is_private;
            const requiredChassisOwnerType = isChassisPrivate && !chassis_owner_type;
            const requiredChassisOwner = (chassis_owner_type && chassis_owner_type == 'customer') && !chassis_owner;
            if (requiredChassisOwnerType) {
                error.chassis_owner_type = `${t('EQUIPMENT')} ${rowNumber} - ${t('PLEASE_SELECT_CHASSIS_OWNER')} `;
            }
            if (requiredChassisOwner) {
                error.chassis_owner = `${t('EQUIPMENT')} ${rowNumber} - ${t('PLEASE_SELECT_CUSTOMER')} `;
            }
            return Object.assign(Object.assign({}, equipment), { error, isValid: Object.keys(error).length === 0 });
        };
        this.validateOrderTypes = () => {
            const { equipments } = this.props;
            const orderTypes = _.groupBy(equipments, (e) => {
                if (e.order) {
                    const { order: { order_type }, } = e;
                    return order_type;
                }
                return null;
            });
            return Object.keys(orderTypes).length === 1;
        };
        this.renderEquipmentForms = () => {
            const { t } = this.props;
            const { equipments } = this.state;
            if (equipments.length === 0) {
                return React.createElement("p", null, "Please select the equipments you would like to update");
            }
            return (React.createElement("div", { className: "bg-white shadow-lg p-4 w-full" },
                React.createElement("table", { className: "table" },
                    React.createElement("thead", null,
                        React.createElement("tr", { className: "font-bold text-grey-darker border-solid border-grey-lightest border-b" },
                            React.createElement("th", null, t('ID')),
                            React.createElement("th", null, t('ASSET_TYPE')),
                            React.createElement("th", null, t('STATUS')),
                            React.createElement("th", null, t('TYPE')),
                            React.createElement("th", null, t('SIZE', { count: 2 })),
                            React.createElement("th", null, t('PRIVATE')),
                            React.createElement("th", null, t('CHASSIS_OWNERSHIP')),
                            React.createElement("th", null, t('CUSTOMER')),
                            React.createElement("th", null, t('APPLY_TO_ALL')),
                            React.createElement("th", null, "\u00A0"))),
                    React.createElement("tbody", null, this.state.equipments.map((equipment) => (React.createElement(EquipmentRow, { key: equipment._id, equipment: equipment, onApplyToAll: this.handleApplyToAll, onFieldChange: this.handleFieldChange, onDeselect: this.handleDeselect })))))));
        };
        this.state = {
            equipments: props.equipments.map((e) => (Object.assign(Object.assign({}, e), { isValid: true, error: {} }))),
            status: '',
            saving: false,
            proTipVisible: true,
        };
    }
    componentDidMount() {
        EquipmentStore.addBulkUpdateChangeListener(this.handleBulkUpdateResultChange);
    }
    componentWillReceiveProps(nextProps) {
        if (!_.isEqual(this.props.equipments, nextProps.equipments)) {
            const equipments = nextProps.equipments.map((e) => (Object.assign(Object.assign({}, e), { isValid: true, error: {} })));
            this.setState({ equipments });
        }
    }
    componentWillUnmount() {
        EquipmentStore.removeBulkUpdateChangeListener(this.handleBulkUpdateResultChange);
    }
    transformRequest(equipments) {
        return equipments.map((eq) => {
            const { _type, _equipmentSize, _equipmentType, equipment_id, status, is_private, chassis_owner, chassis_owner_type, } = eq;
            const chassis_owner_id = ((chassis_owner === null || chassis_owner === void 0 ? void 0 : chassis_owner._id) && chassis_owner_type === 'customer') ? chassis_owner._id : null;
            return {
                _id: eq._id,
                updates: {
                    _type,
                    _equipmentSize,
                    _equipmentType,
                    equipment_id,
                    status,
                    is_private,
                    chassis_owner_type,
                    chassis_owner: chassis_owner_id
                },
            };
        });
    }
    validate(equipments) {
        return equipments.map(this.validateEquipment);
    }
    renderProTip() {
        const { t } = this.props;
        if (!this.state.proTipVisible) {
            return null;
        }
        return (React.createElement(ProTip, { message: t('BULKEDIT_PRO_TIP'), className: { 'mb-4': true }, onClose: this.handleCloseTip }));
    }
    renderStatus() {
        if (!this.state.status) {
            return null;
        }
        return React.createElement(Alert, { type: "success", title: this.state.status });
    }
    renderValidationErrors() {
        const { t } = this.props;
        let validationHeader = t('CORRECT_ISSUES');
        if (this.state.equipments.every((e) => e.isValid)) {
            return null;
        }
        const flattenedErrors = this.state.equipments.reduce((errorList, eq) => {
            const errors = Object.values(eq.error);
            return errorList.concat(errors);
        }, []);
        return (React.createElement(Alert, { type: "error", title: validationHeader },
            React.createElement("ul", null, flattenedErrors.map((error, i) => (React.createElement("li", { key: i }, error))))));
    }
    render() {
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: this.handleHide, backdrop: "static", dialogClassName: "modal-override bg-grey-modal", keyboard: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, titleize(t('BULK_EDIT_EQUIPMENT')))),
            React.createElement(Modal.Body, null,
                this.state.proTipVisible && this.renderProTip(),
                this.renderEquipmentForms()),
            React.createElement(Modal.Footer, null,
                React.createElement("div", { className: "flex flex-wrap items-start justify-end" },
                    React.createElement("div", { className: "mr-4" },
                        this.renderStatus(),
                        this.renderValidationErrors()),
                    React.createElement("div", { className: "flex" },
                        React.createElement("button", { className: "button button-hollow-green mr-2", disabled: this.state.saving, onClick: this.handleClearAll }, titleize(t('CLEAR_ALL'))),
                        React.createElement("button", { onClick: this.handleSave, disabled: this.state.saving, className: "button button-green mr-2" },
                            this.state.saving && (React.createElement("div", { className: "flex items-center" },
                                React.createElement("i", { className: "fa fa-spin fa-circle-o-notch mr-1" }),
                                React.createElement("span", null,
                                    titleize(t('SAVING')),
                                    "..."))),
                            !this.state.saving && React.createElement("span", null, titleize(t('SAVE')))),
                        React.createElement("button", { onClick: this.handleHide, disabled: this.state.saving, className: "button button-hollow-green" }, titleize(t('CLOSE'))))))));
    }
}
BulkEditEquipmentModal.propTypes = {
    show: PropTypes.bool,
    onHide: PropTypes.func.isRequired,
    equipments: PropTypes.array,
};
BulkEditEquipmentModal.defaultProps = {
    show: false,
    equipments: [],
};
function resetEquipment(equipment) {
    return Object.assign(Object.assign({}, equipment), { _type: '', status: null, _equipmentType: '', _equipmentSize: null, is_private: false, chassis_owner_type: null, chassis_owner: null });
}
export default withTranslation()(BulkEditEquipmentModal);
